<template>
<div>
  <div class="properties">
    <property :name="'סוג מנוי'" :value="'פעיל'"/>
    <property :name="'תאריך חיוב הבא'" :value="'מנוי ללא חיוב'"/>
  </div>
</div>
</template>

<script>
import Property from './Property.vue';

export default {
  name: 'FreeSubscriptionSettings',
  components: { Property },
};
</script>

<style scoped lang="scss">

  @import "./settings";

  @include properties;

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/FreeSubscriptionSettings.vue